//This component has the form for creating a new jobsite.
//it will first retrieve a signed URL from the backend, and then use that URL to upload the image to S3.
//on submit it will send a post or put request directly to s3 to upload the image, and then send a post request to the backend to create the jobsite.

import { useEffect, useState } from "react";
import {useSelector } from 'react-redux'
import getSignedUrl from "../actions/getPreSignedURL";

import NewSiteImageUploadForm from "./NewSiteImageUploadForm";

const NewSiteForm = ({initialLatitude, initialLongitude, initialAddress, initialRadius}) => {
    //get token from the redux store
    const {token} = useSelector((state) => state.auth.user )
    
    const [formData, setFormData] = useState({
            jobsiteName: "",
            latitude: "",
            longitude: "",
            address: "",
            radius: "",
    });
     //state to hold the signed URL

     const [signedUrlData, setSignedUrlData] = useState({
        s3Url:"",
        received: false,
        jobsiteID: "",
    });

 
    //useEffect to update the latitude,longitude or address inputs change when the user selects a new location on the map or by typing in the address input
    useEffect( ()=> {
        setFormData(prevState => ({
            ...prevState,
            latitude: initialLatitude,
            longitude: initialLongitude,
            address: initialAddress,
            radius: initialRadius,
        }));
    },[initialLatitude, initialLongitude, initialAddress, initialRadius] )

  
    // submit formData to the backend and get a signed URL for s3 upload.
    const submitForm = async (e) =>{
       //prevernt page reload
        e.preventDefault();
        
        try{
            //get the presigned URL and jobstieID from the backend. 
            const newSiteData =  await getSignedUrl(token,formData);
            
            setSignedUrlData({
                s3Url: newSiteData.s3URL ,
                received : true ,
                jobsiteID : newSiteData.jobSitePK  });

        }catch(error){
            console.log('Error in submitForm: ' + error);
        }
    }


    return (
        <>  
            {signedUrlData.received ? (
               <NewSiteImageUploadForm signedURL = {signedUrlData.s3Url } jobsiteID={signedUrlData.jobsiteID} />
            ): (

                <form className="mt-4" onSubmit={submitForm}>
                    <div className="flex flex-col gap-1">
                        <label
                            htmlFor="jobsiteName"
                            className="text-label text-ink">
                            Jobsite Name
                        </label>
                        <input
                            className="w-full rounded-md border border-border bg-surface px-3 py-2 text-body text-ink placeholder:text-ink-4 focus:outline-none focus:ring-2 focus:ring-brand/40"
                            type="text"
                            id="jobsiteName"
                            required
                            placeholder="2nd Ave Apartments"
                            value={formData.jobsiteName}
                            onChange={(e) => setFormData((prevState) => ({ ...prevState, jobsiteName: e.target.value }))}
                        />
                    </div>
                    <button
                        className="mt-6 bg-ink text-white rounded-lg text-label font-medium px-4 py-2 hover:bg-ink-2"
                        type="submit">
                        Next
                    </button>
                </form>
            )}
        </>
    );
}

export default NewSiteForm;